"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AnalyticsContext_1 = __importDefault(require("../../context/AnalyticsContext"));
var useField_1 = require("../../hooks/useField");
var colors_1 = __importDefault(require("../../style/colors"));
var ErrorMessage_1 = __importDefault(require("./common/ErrorMessage"));
var wrapperHeight = 32;
var optionHeight = 36;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: row;\n  background-color: ", ";\n  height: ", "px;\n  border-radius: ", "px;\n  margin: ", "px 0;\n  user-select: none;\n"], ["\n  display: inline-flex;\n  flex-direction: row;\n  background-color: ", ";\n  height: ", "px;\n  border-radius: ", "px;\n  margin: ", "px 0;\n  user-select: none;\n"])), colors_1.default.shade[5], wrapperHeight, wrapperHeight * 0.5, 0.5 * (optionHeight - wrapperHeight));
var Option = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  padding: 0 20px;\n  height: ", "px;\n  border-radius: ", "px;\n  line-height: ", "px;\n  margin: -", "px 0;\n\n  background-color: ", ";\n  color: ", ";\n\n  span {\n    position: relative;\n    top: 1px;\n  }\n\n  input {\n    position: absolute;\n    height: 0px;\n    width: 0px;\n    opacity: 0;\n  }\n"], ["\n  display: block;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  padding: 0 20px;\n  height: ", "px;\n  border-radius: ", "px;\n  line-height: ", "px;\n  margin: -", "px 0;\n\n  background-color: ",
    ";\n  color: ", ";\n\n  span {\n    position: relative;\n    top: 1px;\n  }\n\n  input {\n    position: absolute;\n    height: 0px;\n    width: 0px;\n    opacity: 0;\n  }\n"])), optionHeight, optionHeight * 0.5, optionHeight, 0.5 * (optionHeight - wrapperHeight), function (props) {
    return props.checked ? colors_1.default.primary.purple : "transparent";
}, function (props) { return (props.checked ? "white" : colors_1.default.primary.purple); });
var RadioField = function (props) {
    var options = props.options, name = props.name;
    var track = react_1.default.useContext(AnalyticsContext_1.default).track;
    var _a = useField_1.useField(props), field = _a[0], meta = _a[1];
    var onChange = field.onChange, onBlur = field.onBlur;
    var error = meta.error, touched = meta.touched, fieldValue = meta.value;
    var showError = Boolean(error && touched);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Wrapper, null, options.map(function (option) {
            var value = option.value, label = option.label, trackEvent = option.trackEvent;
            var checked = value === fieldValue;
            return (react_1.default.createElement(Option, { key: value, checked: checked },
                react_1.default.createElement("input", __assign({ type: "radio", onChange: function (evt) {
                        if (trackEvent)
                            track(trackEvent);
                        onChange(evt);
                    } }, { onBlur: onBlur, checked: checked, name: name, value: value })),
                react_1.default.createElement("span", null, label)));
        })),
        showError ? react_1.default.createElement(ErrorMessage_1.default, { children: error }) : null));
};
exports.default = RadioField;
var templateObject_1, templateObject_2;
